<template>
  <el-select
    v-model="outType"
    clearable=""
    style="width: 100%;"
    placeholder="请选择发货方式"
    @change="onChange">
    <el-option
      v-for="item in options"
      :key="item.value"
      :label="item.label"
      :value="item.value">
    </el-option>
  </el-select>
</template>
<script>
export default {
  name: 'OutTypeSelectNew',
  props: {
    callback: Function,
    value: {
      required: true
    },
    exclude: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {
      list: [
        {
          label: '待定',
          value: '0-'
        },
        {
          label: '正常出库',
          value: '1-1'
        },
        {
          label: '改单出库',
          value: '1-2'
        },
        {
          label: '空包出库',
          value: '2-3'
        },
        {
          label: '刷单出库',
          value: '1-3'
        }
      ]
    }
  },
  computed: {
    outType: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    options({ list, exclude }) {
      return list.filter(i => exclude.indexOf(i.value) === -1)
    }
  },
  methods: {
    onChange() {
      this.callback && this.callback()
    }
  }
}
</script>
